(function () {
  'use strict';

  var SCENT_FAMILIES = [
    { key: 'floral', label: 'Floral', match: /\b(rose|jasmine|lavender|peony|orchid|gardenia|lily|magnolia|tuberose|violet|petal|blossom)\b/i },
    { key: 'citrus', label: 'Citrus', match: /\b(lemon|lime|orange|bergamot|grapefruit|mandarin|citrus|yuzu|tangerine|lemongrass)\b/i },
    { key: 'fresh', label: 'Fresh', match: /\b(cotton|linen|ocean|sea breeze|mint|eucalyptus|aqua|aquatic|cucumber|aloe|crisp|breeze)\b/i },
    { key: 'woody', label: 'Woody', match: /\b(sandalwood|cedar|oud|vetiver|patchouli|teakwood|mahogany|tobacco|leather|amber|pine|musk|sage|woody)\b/i },
    { key: 'fruity', label: 'Fruity', match: /\b(apple|peach|berry|cherry|pineapple|mango|raspberry|strawberry|fig|plum|melon|coconut|pear|cassis)\b/i },
    { key: 'sweet', label: 'Sweet', match: /\b(vanilla|caramel|honey|chocolate|cream|praline|tonka|cocoa|toffee|gourmand|marshmallow|maple)\b/i },
    { key: 'spicy', label: 'Spicy', match: /\b(cinnamon|clove|cardamom|pepper|ginger|saffron|spice|nutmeg|peppercorn)\b/i }
  ];

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function money(cents) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency', currency: 'USD', minimumFractionDigits: 2
    }).format((Number(cents) || 0) / 100);
  }

  // GA4 + dashboard via the shared snippets/ap-track (names <= 40 chars for GA4).
  function track(eventName, detail) {
    var name = eventName.replace(/^scent_membership_/, 'membership_');
    if (typeof window.apTrack === 'function') window.apTrack(name, detail, 'scent_membership');
  }

  function init(root) {
    var dataNode = document.getElementById('ap-membership-data');
    var payload;
    try {
      payload = JSON.parse(dataNode.textContent);
    } catch (error) {
      console.error('[scent-membership] data parse failed', error);
      return;
    }

    var products = Array.isArray(payload.products) ? payload.products : [];
    var state = {
      size: '30',
      frequency: 'biweekly',
      bottleCount: 3,
      selected: [],
      filterType: 'category',
      filterKey: 'all',
      query: '',
      showAll: false,
      step: 1,
      submitting: false
    };

    var builder = root.querySelector('[data-apsm-builder]');
    var grid = builder.querySelector('[data-apsm-products]');
    var categoryFilters = builder.querySelector('[data-apsm-category-filters]');
    var scentFilters = builder.querySelector('[data-apsm-scent-filters]');
    var packs = builder.querySelector('[data-apsm-packs]');
    var railList = builder.querySelector('[data-apsm-rail-list]');
    var peek = builder.querySelector('[data-apsm-peek]');
    var peekBody = builder.querySelector('[data-apsm-peek-body]');
    var reviewList = builder.querySelector('[data-apsm-review-list]');
    var searchInput = builder.querySelector('[data-apsm-search]');
    var results = builder.querySelector('[data-apsm-results]');
    var foot = builder.querySelector('.os-foot');

    function variantFor(product) {
      return product && product.variants ? product.variants[state.size] : null;
    }

    function planFor(variant) {
      return variant && variant.plans ? variant.plans[state.frequency] : null;
    }

    function planForFrequency(variant, frequency) {
      return variant && variant.plans ? variant.plans[frequency] : null;
    }

    function planDiscount() {
      return 20;
    }

    function frequencyLabel() {
      return { biweekly: 'every 2 weeks', monthly: 'every month', bimonthly: 'every 2 months' }[state.frequency];
    }

    function productById(id) {
      return products.find(function (product) { return String(product.id) === String(id); });
    }

    function selectedProducts() {
      return state.selected.map(productById).filter(Boolean);
    }

    function productFamilies(product) {
      var text = [product.title, product.notes].join(' ');
      return SCENT_FAMILIES.filter(function (family) { return family.match.test(text); })
        .map(function (family) { return family.key; });
    }

    function availableProducts() {
      return products.filter(function (product) {
        var variant = variantFor(product);
        return variant && variant.available && planFor(variant);
      });
    }

    function totals() {
      return selectedProducts().reduce(function (sum, product) {
        var variant = variantFor(product);
        var plan = planFor(variant);
        sum.regular += variant.price;
        sum.member += plan.memberPrice;
        return sum;
      }, { regular: 0, member: 0 });
    }

    function configurationTotals(frequency) {
      var product = products.find(function (item) {
        var variant = item.variants ? item.variants[state.size] : null;
        return variant && variant.available && planForFrequency(variant, frequency);
      });
      if (!product) return { regular: 0, member: 0, unitRegular: 0 };
      var variant = product.variants[state.size];
      var plan = planForFrequency(variant, frequency);
      return {
        regular: variant.price * state.bottleCount,
        member: plan.memberPrice * state.bottleCount,
        unitRegular: variant.price
      };
    }

    function renderSizeOptions() {
      builder.querySelectorAll('[data-apsm-sizes] [data-size]').forEach(function (button) {
        var size = button.dataset.size;
        var product = products.find(function (item) {
          var variant = item.variants ? item.variants[size] : null;
          return variant && variant.available && planForFrequency(variant, state.frequency);
        });
        var priceNode = button.querySelector('[data-apsm-size-price]');
        var perMlNode = button.querySelector('[data-apsm-size-perml]');
        if (!product) {
          priceNode.textContent = 'Unavailable';
          perMlNode.textContent = '';
          button.disabled = true;
          return;
        }
        var variant = product.variants[size];
        var plan = planForFrequency(variant, state.frequency);
        button.disabled = false;
        priceNode.textContent = money(plan.memberPrice) + ' / delivery';
        priceNode.dataset.mobilePrice = money(plan.memberPrice);
        perMlNode.textContent = '$' + ((plan.memberPrice / 100) / Number(size)).toFixed(2) + '/ml · ' + plan.discount + '% off';
        perMlNode.dataset.mobilePerMl = '$' + ((plan.memberPrice / 100) / Number(size)).toFixed(2) + '/ml';
      });
    }

    function remaining() {
      return Math.max(0, state.bottleCount - state.selected.length);
    }

    function progressSegments(className) {
      var html = '';
      for (var index = 0; index < state.bottleCount; index += 1) {
        html += '<span class="' + className + (index < state.selected.length ? ' is-on' : '') + '"></span>';
      }
      return html;
    }

    function filterProducts() {
      return availableProducts().filter(function (product) {
        var matchesFilter = state.filterType === 'category'
          ? state.filterKey === 'all' || product.category === state.filterKey
          : productFamilies(product).indexOf(state.filterKey) !== -1;
        var haystack = (product.title + ' ' + product.notes).toLowerCase();
        return matchesFilter && (!state.query || haystack.indexOf(state.query) !== -1);
      });
    }

    function renderFilters() {
      var available = availableProducts();
      var categories = [
        { key: 'all', label: 'All' }, { key: 'hotel', label: 'Hotel' },
        { key: 'perfume', label: 'Perfume' }, { key: 'nature', label: 'Nature' }
      ];
      categoryFilters.innerHTML = '<span class="os-chips-label">Type</span>' + categories.map(function (category) {
        var count = category.key === 'all' ? available.length : available.filter(function (product) { return product.category === category.key; }).length;
        if (!count && category.key !== 'all') return '';
        var active = state.filterType === 'category' && state.filterKey === category.key;
        return '<button class="os-chip' + (active ? ' is-on' : '') + '" type="button" data-filter-category="' + category.key + '">' + category.label + '<span class="os-chip__n">' + count + '</span></button>';
      }).join('');

      scentFilters.innerHTML = '<span class="os-chips-label">Scent</span>' + SCENT_FAMILIES.map(function (family) {
        var count = available.filter(function (product) { return productFamilies(product).indexOf(family.key) !== -1; }).length;
        if (!count) return '';
        var active = state.filterType === 'scent' && state.filterKey === family.key;
        return '<button class="os-chip os-chip--scent' + (active ? ' is-on' : '') + '" type="button" data-filter-scent="' + family.key + '">' + family.label + '<span class="os-chip__n">' + count + '</span></button>';
      }).join('');
    }

    // Best-loved first: most-reviewed scents in a category for the current size.
    function bestLoved(category, count, size) {
      var pool = products.filter(function (product) {
        var variant = product.variants ? product.variants[size || state.size] : null;
        return variant && variant.available && planFor(variant) && (category === 'mix' || product.category === category);
      }).sort(function (a, b) { return (Number(b.reviewCount) || 0) - (Number(a.reviewCount) || 0); });
      if (category !== 'mix') return pool.slice(0, count);
      var lanes = ['hotel', 'perfume', 'nature'].map(function (key) {
        return pool.filter(function (product) { return product.category === key; });
      });
      var mixed = [];
      for (var index = 0; mixed.length < count && index < pool.length; index += 1) {
        var lane = lanes[index % 3];
        var next = lane[Math.floor(index / 3)];
        if (next) mixed.push(next);
      }
      return mixed.length ? mixed : pool.slice(0, count);
    }

    function renderPacks() {
      var definitions = [
        { key: 'hotel', name: 'Hotel Favorites', sub: 'Lobby-inspired scents' },
        { key: 'perfume', name: 'Perfume Icons', sub: 'Fine-fragrance inspired' },
        { key: 'nature', name: 'Nature Reset', sub: 'Fresh, grounding scents' }
      ];
      packs.innerHTML = definitions.map(function (definition) {
        var picks = bestLoved(definition.key, Math.max(3, state.bottleCount));
        if (!picks.length) return '';
        return '<button class="os-pack" type="button" data-pack="' + definition.key + '">' +
          '<span class="os-pack__name">' + definition.name + '</span>' +
          '<span class="os-pack__strip">' + picks.slice(0, 3).map(function (product) { return '<img src="' + escapeHtml(product.image) + '" alt="" width="36" height="36" loading="lazy">'; }).join('') + '</span>' +
          '<span class="os-pack__sub">' + (state.bottleCount === 1 ? 'Our top pick' : 'All ' + state.bottleCount + ' spots') + ' · ' + definition.sub + '</span></button>';
      }).join('');
    }

    // One card design for the builder grid and the guided picker.
    function cardHtml(product, opts) {
      var variant = product.variants[opts.size];
      var plan = planForFrequency(variant, opts.frequency);
      var rating = Number(product.rating || 0);
      var reviewCount = Number(product.reviewCount || 0);
      var ratingHtml = rating > 0 && reviewCount > 0
        ? '<div class="os-card__rating" aria-label="Rated ' + rating.toFixed(1) + ' out of 5">' +
            '<span class="os-card__stars" style="--pct:' + (rating / 5 * 100).toFixed(0) + '%">★★★★★</span>' +
            '<span class="os-card__rnum">' + rating.toFixed(1) + '</span>' +
            '<span class="os-card__rcnt">(' + reviewCount + ')</span></div>'
        : '';
      return '<article class="os-card' + (opts.picked ? ' is-picked' : '') + '" ' + opts.idAttr + '="' + escapeHtml(product.id) + '" data-picked-label="' + escapeHtml(opts.label) + '" tabindex="0" role="button" aria-pressed="' + (opts.picked ? 'true' : 'false') + '"' + (opts.style ? ' style="' + opts.style + '"' : '') + '>' +
        '<div class="os-card__check"></div><div class="os-card__img"><div class="os-card__cat os-card__cat--' + escapeHtml(product.category) + '">' + escapeHtml(product.category) + '</div>' +
        '<img src="' + escapeHtml(product.image) + '" alt="' + escapeHtml(product.title) + ' waterless fragrance oil" width="300" height="300" loading="lazy"></div>' +
        '<div class="os-card__body"><h3 class="os-card__title">' + escapeHtml(product.title) + '</h3>' +
        '<p class="os-card__notes">' + escapeHtml(product.notes || 'Waterless home fragrance oil') + '</p>' +
        '<div class="os-card__price">' + money(plan.memberPrice) + '<small>/' + opts.size + ' ml bottle, per delivery</small></div>' +
        '<div class="apsm-card-saving"><s>' + money(variant.price) + '</s> ' + plan.discount + '% off</div>' +
        ratingHtml + '</div></article>';
    }

    function renderCards() {
      var list = filterProducts();
      list.sort(function (a, b) {
        var aIndex = state.selected.indexOf(String(a.id));
        var bIndex = state.selected.indexOf(String(b.id));
        if (aIndex === -1 && bIndex === -1) return 0;
        if (aIndex === -1) return 1;
        if (bIndex === -1) return -1;
        return aIndex - bIndex;
      });
      if (!list.length) {
        grid.innerHTML = '<div class="os-empty"><div class="os-empty__icon">⌖</div><h3 class="os-empty__h">No matches</h3><p class="os-empty__sub">Try another category or scent family for this bottle size.</p><button class="os-empty__reset" type="button" data-reset-filter>See all scents</button></div>';
        results.innerHTML = '<span>No matching scents</span>';
        return;
      }
      var limitList = state.filterType === 'category' && state.filterKey === 'all' && !state.query && !state.showAll ? list.slice(0, 18) : list;
      grid.innerHTML = limitList.map(function (product) {
        var quantity = state.selected.filter(function (id) { return id === String(product.id); }).length;
        return cardHtml(product, {
          size: state.size, frequency: state.frequency, picked: quantity > 0, idAttr: 'data-product-id',
          label: 'ADDED' + (quantity > 1 ? ' × ' + quantity : '')
        });
      }).join('');
      results.innerHTML = limitList.length < list.length
        ? '<span>Showing ' + limitList.length + ' of ' + list.length + ' scents</span><button type="button" data-apsm-show-all>Show all ' + list.length + ' scents</button>'
        : '<span>Showing ' + list.length + (state.query ? ' matching' : '') + ' scents</span>';
    }

    function summaryRow(product, mobile) {
      var variant = variantFor(product);
      var plan = planFor(variant);
      if (mobile) {
        return '<div class="os-peek__row"><div class="os-peek__thumb"><img src="' + escapeHtml(product.image) + '" alt=""></div><span class="os-peek__name">' + escapeHtml(product.title) + '</span><button class="os-peek__remove" type="button" data-remove-id="' + escapeHtml(product.id) + '" aria-label="Remove ' + escapeHtml(product.title) + '">×</button></div>';
      }
      return '<div class="os-rail__item"><div class="os-rail__thumb"><img src="' + escapeHtml(product.image) + '" alt=""></div><span class="os-rail__name">' + escapeHtml(product.title) + '</span><span class="apsm-rail-price">' + money(plan.memberPrice) + '</span><button class="os-rail__remove" type="button" data-remove-id="' + escapeHtml(product.id) + '" aria-label="Remove ' + escapeHtml(product.title) + '">×</button></div>';
    }

    function renderSummary() {
      var selected = selectedProducts();
      var sum = totals();
      var missing = remaining();
      var emptyRail = '';
      var emptyPeek = '';
      for (var index = 0; index < missing; index += 1) {
        emptyRail += '<div class="os-rail__item os-rail__item--empty">Pick scent ' + (selected.length + index + 1) + '</div>';
        emptyPeek += '<div class="os-peek__row os-peek__row--empty">Pick scent ' + (selected.length + index + 1) + '</div>';
      }
      railList.innerHTML = selected.map(function (product) { return summaryRow(product, false); }).join('') + emptyRail;
      peekBody.innerHTML = selected.map(function (product) { return summaryRow(product, true); }).join('') + emptyPeek;

      builder.querySelector('[data-apsm-rail-count]').textContent = selected.length;
      builder.querySelector('[data-apsm-rail-required]').textContent = state.bottleCount;
      builder.querySelector('[data-apsm-rail-regular]').textContent = money(sum.regular);
      builder.querySelector('[data-apsm-rail-savings]').textContent = '−' + money(sum.regular - sum.member);
      builder.querySelector('[data-apsm-rail-savings-label]').textContent = 'Your ' + planDiscount() + '% savings';
      builder.querySelector('[data-apsm-rail-total]').textContent = money(sum.member);
      builder.querySelector('[data-apsm-peek-count]').textContent = selected.length + '/' + state.bottleCount;
      builder.querySelector('[data-apsm-peek-label]').textContent = 'scents · ' + money(sum.member) + ' first order';
      builder.querySelector('[data-apsm-builder-sub]').innerHTML = state.bottleCount + ' bottles ' + frequencyLabel() + ' · <span class="os-save">Save ' + planDiscount() + '%</span> · swap future scents online';
      builder.querySelector('[data-apsm-progress-label]').textContent = selected.length + ' of ' + state.bottleCount + ' scents';
      builder.querySelector('[data-apsm-monthly]').textContent = money(sum.member) + '/order';
      builder.querySelector('[data-apsm-progress]').innerHTML = progressSegments('os-tiers__seg');
      builder.querySelector('[data-apsm-foot-progress]').innerHTML = progressSegments('os-foot__seg');
      builder.querySelector('[data-apsm-foot-count]').textContent = selected.length;
      builder.querySelector('[data-apsm-foot-message]').textContent = 'of ' + state.bottleCount + ' selected';
      builder.querySelector('[data-apsm-foot-picks]').innerHTML = selected.map(function (product) { return '<span class="os-foot__pick"><img src="' + escapeHtml(product.image) + '" alt=""></span>'; }).join('');

      var shippingStatuses = builder.querySelectorAll('[data-apsm-shipping-status]');
      var shippingMessages = builder.querySelectorAll('[data-apsm-shipping-message]');
      var shippingMeters = builder.querySelectorAll('[data-apsm-shipping-meter]');
      var shippingOrderValue = configurationTotals(state.frequency).member;
      var shippingRemaining = Math.max(0, 4999 - shippingOrderValue);
      var shippingQualified = shippingRemaining === 0;
      shippingStatuses.forEach(function (status) {
        status.classList.toggle('is-qualified', shippingQualified);
      });
      var shippingMessage = shippingQualified
        ? '<b>Free shipping unlocked</b> for each qualifying membership order.'
        : '<b>Add ' + money(shippingRemaining) + ' per order</b> to unlock free shipping.';
      shippingMessages.forEach(function (message) {
        message.innerHTML = shippingMessage;
      });
      shippingMeters.forEach(function (meter) {
        var shippingValue = Math.min(shippingOrderValue, 4999);
        meter.setAttribute('aria-valuenow', shippingValue);
        meter.style.setProperty('--apsm-shipping-progress', ((shippingValue / 4999) * 100).toFixed(2) + '%');
      });
      var reviewShipping = builder.querySelector('[data-apsm-review-shipping]');
      reviewShipping.classList.toggle('is-qualified', shippingQualified);
      builder.querySelector('[data-apsm-review-shipping-value]').textContent = shippingQualified ? 'FREE' : 'Calculated at checkout';

      ['monthly', 'biweekly', 'bimonthly'].forEach(function (frequency) {
        var estimate = configurationTotals(frequency);
        var totalNode = builder.querySelector('[data-apsm-frequency-total="' + frequency + '"]');
        if (totalNode) totalNode.textContent = money(estimate.member);
        var monthNode = totalNode && totalNode.closest('[data-frequency]').querySelector('.apsm-term__monthly');
        if (monthNode) {
          monthNode.textContent = frequency === 'biweekly'
            ? 'About ' + money(Math.round(estimate.member * 26 / 12)) + '/month · charged per shipment'
            : 'Charged per shipment';
        }
      });

      var configured = configurationTotals(state.frequency);
      root.querySelector('[data-apsm-savings-regular]').textContent = money(configured.regular);
      root.querySelector('[data-apsm-savings-amount]').textContent = '−' + money(configured.regular - configured.member);
      root.querySelector('[data-apsm-savings-total]').textContent = money(configured.member);
      root.querySelector('[data-apsm-savings-percent]').textContent = planDiscount() + '%';
      root.querySelector('[data-apsm-savings-monthly]').textContent = money(configured.member);
      root.querySelector('[data-apsm-savings-config]').textContent = state.bottleCount + ' × ' + state.size + ' ml · delivered ' + frequencyLabel() + ' · no discount code needed';

      var message = missing ? 'Pick ' + missing + ' to continue →' : 'Review membership →';
      var reviewCta = builder.querySelector('[data-apsm-review-cta]');
      var peekCta = builder.querySelector('[data-apsm-peek-cta]');
      reviewCta.textContent = message;
      peekCta.textContent = message;
      reviewCta.disabled = missing !== 0;
      peekCta.disabled = missing !== 0;
      builder.querySelector('[data-apsm-next]').disabled = missing !== 0;

      var nudge = builder.querySelector('[data-apsm-nudge]');
      nudge.classList.add('is-on');
      nudge.classList.toggle('is-complete', missing === 0);
      builder.querySelector('[data-apsm-nudge-message]').innerHTML = selected.length === 0
        ? 'Choose <b>' + missing + ' scents</b> for your first delivery.'
        : missing
          ? 'Choose <b>' + missing + ' more scent' + (missing === 1 ? '' : 's') + '</b> for your delivery.'
          : '<b>First delivery complete.</b> Review membership.';
    }

    function renderReview() {
      var selected = selectedProducts();
      var sum = totals();
      reviewList.innerHTML = selected.map(function (product, index) {
        var variant = variantFor(product);
        var plan = planFor(variant);
        return '<li class="os-review__item"><span class="os-review__num">' + (index + 1) + '</span><span class="os-review__thumb"><img src="' + escapeHtml(product.image) + '" alt=""></span><span><span class="os-review__title">' + escapeHtml(product.title) + '</span><span class="os-review__meta">' + state.size + ' ml · delivered ' + frequencyLabel() + '</span></span><span class="os-review__price">' + money(plan.memberPrice) + '/order</span></li>';
      }).join('');
      builder.querySelector('[data-apsm-review-sub]').textContent = state.bottleCount + ' × ' + state.size + ' ml · delivered ' + frequencyLabel();
      builder.querySelector('[data-apsm-review-regular]').textContent = money(sum.regular);
      builder.querySelector('[data-apsm-review-savings]').textContent = '−' + money(sum.regular - sum.member);
      builder.querySelector('[data-apsm-review-savings-label]').textContent = 'Your ' + planDiscount() + '% savings';
      builder.querySelector('[data-apsm-review-shipping-label]').textContent = 'Shipping for this order';
      builder.querySelector('[data-apsm-review-total-label]').textContent = 'First order';
      builder.querySelector('[data-apsm-review-total]').textContent = money(sum.member);
      builder.querySelector('[data-apsm-review-note]').innerHTML = '<strong>' + money(sum.member) + ' charged for the first order.</strong> Future orders recur ' + frequencyLabel() + ' until canceled. Shipping and taxes, if applicable, are calculated at checkout. Use Bottle Swap to change future scents.';
    }

    function render() {
      state.selected = state.selected.filter(function (id) {
        var variant = variantFor(productById(id));
        return variant && variant.available && planFor(variant);
      }).slice(0, state.bottleCount);
      builder.querySelector('[data-apsm-count]').textContent = state.bottleCount;
      renderSizeOptions();
      renderFilters();
      renderPacks();
      renderCards();
      renderSummary();
      renderReview();
    }

    function addProduct(id) {
      id = String(id);
      if (state.selected.length < state.bottleCount) {
        state.selected.push(id);
        track('scent_membership_scent_added', { product_id: id, size_ml: state.size });
      } else {
        grid.classList.remove('is-shake');
        void grid.offsetWidth;
        grid.classList.add('is-shake');
        return;
      }
      render();
    }

    function removeProduct(id) {
      var selectedIndex = state.selected.lastIndexOf(String(id));
      if (selectedIndex !== -1) state.selected.splice(selectedIndex, 1);
      render();
    }

    function toggleProduct(id) {
      id = String(id);
      if (state.selected.indexOf(id) !== -1) {
        state.selected = state.selected.filter(function (selectedId) { return selectedId !== id; });
        render();
        return;
      }
      addProduct(id);
    }

    function goStep(step) {
      if (step === 2 && remaining()) return;
      state.step = step;
      builder.querySelectorAll('[data-apsm-pane]').forEach(function (pane) { pane.classList.toggle('is-active', Number(pane.dataset.apsmPane) === step); });
      builder.querySelectorAll('[data-apsm-step]').forEach(function (item) {
        var itemStep = Number(item.dataset.apsmStep);
        item.classList.toggle('is-current', itemStep === step);
        item.classList.toggle('is-done', itemStep < step);
      });
      builder.querySelector('[data-apsm-back]').style.display = step === 2 ? '' : 'none';
      var next = builder.querySelector('[data-apsm-next]');
      next.textContent = step === 2 ? 'Checkout →' : 'Continue →';
      next.classList.toggle('os-btn--gold', step === 2);
      next.classList.toggle('os-btn--ink', step !== 2);
      peek.classList.remove('is-open');
      peek.style.display = step === 1 ? '' : 'none';
      builder.scrollIntoView({ behavior: 'smooth', block: 'start' });
      if (step === 2) track('scent_membership_review_opened', { bottle_count: state.bottleCount, size_ml: state.size });
      updateFootVisibility();
    }

    function updateFootVisibility() {
      var rect = builder.getBoundingClientRect();
      var inBuilder = rect.top < window.innerHeight - 80 && rect.bottom > 100;
      foot.classList.toggle('is-in-builder', state.step === 2 && inBuilder);
      // The guide's own scent tray owns the bottom edge while it's picking.
      var picking = guide && guide.dataset.step === 'scents';
      peek.classList.toggle('is-in-builder', state.step === 1 && inBuilder && !picking);
    }

    root.querySelectorAll('a[href="#build-membership"]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault();
        var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        builder.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
      });
    });

    async function submit(trigger) {
      if (state.submitting || remaining()) return;
      state.submitting = true;
      var button = trigger || builder.querySelector('[data-apsm-next]');
      var idleLabel = button.textContent;
      button.disabled = true;
      button.textContent = 'Preparing checkout…';
      var items = selectedProducts().map(function (product) {
        var variant = variantFor(product);
        var plan = planFor(variant);
        return {
          id: Number(variant.id), quantity: 1, selling_plan: Number(plan.sellingPlan),
          properties: {
            '_Scent Membership': 'Delivery ' + frequencyLabel() + ' · pay per order',
            '_Bottle size': state.size + ' ml',
            '_Bottle count per order': String(state.bottleCount),
            '_First delivery scent': product.title
          }
        };
      });
      try {
        var response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        });
        if (!response.ok) {
          var errorPayload = await response.json().catch(function () { return {}; });
          throw new Error(errorPayload.description || 'The membership could not be added.');
        }
        track('scent_membership_checkout_started', { bottle_count: state.bottleCount, size_ml: state.size, frequency: state.frequency, discount_percent: planDiscount(), source: trigger ? 'guide' : 'builder' });
        window.location.assign('/checkout');
      } catch (error) {
        state.submitting = false;
        button.disabled = false;
        button.textContent = error.message || idleLabel;
      }
    }

    builder.addEventListener('click', function (event) {
      var size = event.target.closest('[data-size]');
      var frequency = event.target.closest('[data-frequency]');
      var category = event.target.closest('[data-filter-category]');
      var scent = event.target.closest('[data-filter-scent]');
      var card = event.target.closest('[data-product-id]');
      var remove = event.target.closest('[data-remove-id]');
      var pack = event.target.closest('[data-pack]');
      if (frequency) {
        state.frequency = frequency.dataset.frequency;
        builder.querySelectorAll('[data-frequency]').forEach(function (item) {
          var active = item === frequency;
          item.classList.toggle('is-on', active);
          item.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        track('scent_membership_frequency_selected', { frequency: state.frequency, discount_percent: planDiscount() });
        render();
      } else if (size) {
        state.size = size.dataset.size;
        builder.querySelectorAll('[data-size]').forEach(function (item) {
          var active = item === size;
          item.classList.toggle('is-on', active);
          item.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        track('scent_membership_size_selected', { size_ml: state.size });
        render();
      } else if (category) {
        state.filterType = 'category'; state.filterKey = category.dataset.filterCategory; state.showAll = false; render();
      } else if (scent) {
        state.filterType = 'scent'; state.filterKey = scent.dataset.filterScent; state.showAll = false; render();
      } else if (remove) {
        removeProduct(remove.dataset.removeId);
      } else if (pack) {
        state.selected = bestLoved(pack.dataset.pack, state.bottleCount).map(function (product) { return String(product.id); });
        render();
      } else if (event.target.closest('[data-reset-filter]')) {
        state.filterType = 'category'; state.filterKey = 'all'; state.query = ''; state.showAll = false; searchInput.value = ''; render();
      } else if (event.target.closest('[data-apsm-show-all]')) {
        state.showAll = true; renderCards();
      } else if (card) {
        toggleProduct(card.dataset.productId);
      } else if (event.target.closest('[data-apsm-count-minus]')) {
        if (state.bottleCount > 1) { state.bottleCount -= 1; render(); }
      } else if (event.target.closest('[data-apsm-count-plus]')) {
        state.bottleCount += 1; render();
      } else if (event.target.closest('[data-apsm-review-cta]') || event.target.closest('[data-apsm-peek-cta]')) {
        goStep(2);
      } else if (event.target.closest('[data-apsm-back]')) {
        goStep(1);
      } else if (event.target.closest('[data-apsm-next]')) {
        if (state.step === 1) goStep(2); else submit();
      } else if (event.target.closest('[data-apsm-peek-handle]')) {
        peek.classList.toggle('is-open');
      }
    });

    var proofFirst = root.querySelector('[data-apsm-proof-scent]');
    var proofOriginalName = proofFirst ? proofFirst.dataset.name : '';
    var proofSelectedName = proofOriginalName;

    function updateProofChoice(proofScent) {
      proofSelectedName = proofScent.dataset.name;
      root.querySelectorAll('[data-apsm-proof-scent]').forEach(function (item) { item.setAttribute('aria-pressed', item === proofScent ? 'true' : 'false'); });
      root.querySelector('[data-apsm-proof-summary]').textContent = proofSelectedName === proofOriginalName
        ? proofOriginalName + ' stays in your lineup'
        : proofOriginalName + ' → ' + proofSelectedName;
      var saveButton = root.querySelector('[data-apsm-proof-save]');
      saveButton.disabled = proofSelectedName === proofOriginalName;
      saveButton.textContent = saveButton.disabled ? 'Select a replacement' : 'Confirm for next delivery';
      root.querySelectorAll('.apsm-swap-flow span').forEach(function (step, index) {
        step.classList.toggle('is-done', index === 0 || (proofSelectedName !== proofOriginalName && index === 1));
        step.classList.toggle('is-active', index === (proofSelectedName === proofOriginalName ? 1 : 2));
      });
      root.querySelector('[data-apsm-proof-confirmation]').hidden = true;
    }

    root.addEventListener('click', function (event) {
      var proofScent = event.target.closest('[data-apsm-proof-scent]');
      var proofSave = event.target.closest('[data-apsm-proof-save]');
      var proofReset = event.target.closest('[data-apsm-proof-reset]');
      if (proofScent) {
        updateProofChoice(proofScent);
        track('scent_membership_bottle_swap_preview_used', { scent: proofScent.dataset.name });
      } else if (proofSave && !proofSave.disabled) {
        proofSave.disabled = true;
        proofSave.textContent = 'Saved for next delivery';
        root.querySelectorAll('.apsm-swap-flow span').forEach(function (step) { step.classList.add('is-done'); step.classList.remove('is-active'); });
        root.querySelector('[data-apsm-proof-confirmation-name]').textContent = proofSelectedName + ' is now in your next delivery.';
        root.querySelector('[data-apsm-proof-confirmation]').hidden = false;
        track('scent_membership_bottle_swap_preview_saved', { scent: proofSelectedName });
      } else if (proofReset) {
        var proofUndoneName = proofSelectedName;
        updateProofChoice(root.querySelector('[data-apsm-proof-scent][data-name="' + proofOriginalName + '"]'));
        track('scent_membership_bottle_swap_preview_undone', { scent: proofUndoneName });
      }
    });

    searchInput.addEventListener('input', function () {
      state.query = searchInput.value.trim().toLowerCase();
      state.showAll = Boolean(state.query);
      renderCards();
    });

    window.addEventListener('scroll', updateFootVisibility, { passive: true });
    window.addEventListener('resize', updateFootVisibility);

    builder.addEventListener('keydown', function (event) {
      var card = event.target.closest('[data-product-id]');
      if (card && (event.key === 'Enter' || event.key === ' ')) {
        event.preventDefault(); toggleProduct(card.dataset.productId);
      }
    });


    /* ---------------------------------------------------------------- */
    /* Guided plan: diffusers -> mood -> schedule -> the shopper picks   */
    /* every scent -> a ready plan, one full screen at a time.           */
    /* ---------------------------------------------------------------- */
    var guide = root.querySelector('[data-apsm-guide]');
    if (guide) {
      var SCREENS = ['intro', 'diffusers', 'mood', 'schedule', 'scents', 'plan'];
      // Each schedule ships a bottle sized to last until the next delivery
      // (owner: 30 ml lasts about 2 weeks).
      var SCHEDULE_SIZE = { biweekly: '30', monthly: '60', bimonthly: '120' };
      var answers = { diffusers: 0, rooms: [], extraRooms: 0, mood: '', schedule: '', bottles: 0, picks: [], tab: 'all', family: '', query: '' };
      var bar = guide.querySelector('[data-apsm-guide-bar]');
      var pickGrid = guide.querySelector('[data-apsm-pick-grid]');
      var pickSearch = guide.querySelector('[data-apsm-pick-search]');
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      // One label per bottle: the rooms tapped in step 1, then any extras.
      var slotLabels = function () {
        var labels = answers.rooms.map(function (key) {
          var tile = guide.querySelector('[data-room="' + key + '"]');
          return tile ? tile.dataset.roomLabel : 'Room';
        });
        for (var index = 0; index < answers.extraRooms; index += 1) labels.push(answers.extraRooms > 1 ? 'Other room ' + (index + 1) : 'Other room');
        while (labels.length < answers.bottles) labels.push(labels.length && roomCount() ? 'Extra scent' : 'Scent ' + (labels.length + 1));
        return labels.slice(0, answers.bottles);
      };

      var roomCount = function () { return answers.rooms.length + answers.extraRooms; };

      var renderRooms = function () {
        guide.querySelectorAll('[data-room]').forEach(function (tile) {
          var on = answers.rooms.indexOf(tile.dataset.room) !== -1;
          tile.classList.toggle('is-on', on);
          tile.setAttribute('aria-pressed', on ? 'true' : 'false');
          tile.querySelector('small').textContent = on ? 'Diffuser here' : 'Tap to scent';
        });
        var extraTile = guide.querySelector('[data-room-extra]');
        extraTile.classList.toggle('is-on', answers.extraRooms > 0);
        guide.querySelector('[data-room-extra-count]').textContent = answers.extraRooms;
        guide.querySelector('[data-room-extra-minus]').disabled = answers.extraRooms === 0;
        var count = roomCount();
        var counter = guide.querySelector('[data-apsm-rooms-count]');
        if (counter.textContent !== String(count)) {
          counter.textContent = count;
          counter.classList.remove('is-bump');
          void counter.offsetWidth;
          counter.classList.add('is-bump');
        }
        guide.querySelector('[data-apsm-rooms-summary]').classList.toggle('is-ready', count > 0);
        guide.querySelector('[data-apsm-rooms-text]').innerHTML = count
          ? (count === 1 ? 'room' : 'rooms') + ' &rarr; <b>' + count + ' bottle' + (count === 1 ? '' : 's') + '</b> each delivery'
          : 'Tap the rooms where you run a diffuser.';
        guide.querySelector('[data-apsm-rooms-next]').disabled = !count;
      };

      var guideSize = function () { return answers.size || SCHEDULE_SIZE[answers.schedule] || '30'; };

      /* ---- motion helpers (reduced motion: values snap, fades stay in CSS) ---- */
      var countUp = function (node, cents) {
        var from = Number(node.dataset.cents || 0);
        node.dataset.cents = cents;
        if (reducedMotion || from === cents) { node.textContent = money(cents); return; }
        var started = null;
        var step = function (now) {
          if (!started) started = now;
          var t = Math.min(1, (now - started) / 520);
          var eased = 1 - Math.pow(1 - t, 3);
          node.textContent = money(Math.round(from + (cents - from) * eased));
          if (t < 1) requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
      };

      // A picked bottle flies from its card into its tray slot.
      var flyToSlot = function (fromImg, slotIndex) {
        if (reducedMotion || !fromImg) return;
        var slot = guide.querySelectorAll('[data-apsm-pick-slots] > *')[slotIndex];
        // Desktop hides the slot thumbnails and shows the side-rail list instead.
        if (!slot || !slot.offsetParent) slot = guide.querySelectorAll('[data-apsm-pick-list] > li')[slotIndex];
        if (!slot || !slot.offsetParent) return;
        var a = fromImg.getBoundingClientRect();
        var b = slot.getBoundingClientRect();
        var ghost = fromImg.cloneNode();
        ghost.className = 'apsm-fly';
        ghost.removeAttribute('loading');
        ghost.style.cssText = 'left:' + a.left + 'px;top:' + a.top + 'px;width:' + a.width + 'px;height:' + a.height + 'px;';
        document.body.appendChild(ghost);
        var dx = b.left + b.width / 2 - (a.left + a.width / 2);
        var dy = b.top + b.height / 2 - (a.top + a.height / 2);
        var scale = b.width / a.width;
        ghost.animate([
          { transform: 'translate(0,0) scale(1)', opacity: 1, borderRadius: '12px' },
          { transform: 'translate(' + dx * .55 + 'px,' + (dy * .55 - 60) + 'px) scale(' + (scale + .35) + ') rotate(-8deg)', opacity: 1, offset: .55 },
          { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(' + scale + ')', opacity: .2, borderRadius: '10px' }
        ], { duration: 620, easing: 'cubic-bezier(.5,0,.3,1)' }).onfinish = function () {
          ghost.remove();
          slot.classList.add('is-landed');
        };
      };

      var ripple = function (event) {
        var host = event.target.closest('.apsm-room, .apsm-guide__option, .os-card, .apsm-button, .apsm-size-option, .apsm-pick__schedule button');
        if (!host || !guide.contains(host)) return;
        var r = host.getBoundingClientRect();
        var dot = document.createElement('span');
        var size = Math.max(r.width, r.height) * 1.2;
        dot.className = 'apsm-ripple';
        dot.style.cssText = 'width:' + size + 'px;height:' + size + 'px;left:' + (event.clientX - r.left - size / 2) + 'px;top:' + (event.clientY - r.top - size / 2) + 'px;';
        host.appendChild(dot);
        setTimeout(function () { dot.remove(); }, 650);
      };

      // Stagger the children of the incoming screen (CSS reads --i).
      var stagger = function (screen) {
        var items = screen.querySelectorAll(':scope > *, :scope .apsm-rooms > *, :scope .apsm-guide__options > *, :scope .apsm-plan__scroll > *, :scope .apsm-plan__foot > *, :scope .apsm-pick__top > *');
        items.forEach(function (item, index) { item.style.setProperty('--i', Math.min(index, 14)); });
      };

      // Scents that can ship on the chosen schedule and size, most-reviewed first.
      var pickable = function () {
        var size = guideSize();
        return products.filter(function (product) {
          var variant = product.variants ? product.variants[size] : null;
          return variant && variant.available && planForFrequency(variant, answers.schedule || 'biweekly');
        }).sort(function (a, b) { return (Number(b.reviewCount) || 0) - (Number(a.reviewCount) || 0); });
      };

      // Phones scroll the page: after a filter change, show the top of the new results
      // just under the pinned filter bar (only if we were already past it).
      var toResultsTop = function () {
        if (window.innerWidth > 900) return;
        var bar = guide.querySelector('[data-apsm-pick-filters]');
        var top = pickGrid.getBoundingClientRect().top + window.scrollY - (bar ? bar.offsetHeight : 0) - 8;
        if (window.scrollY > top) window.scrollTo(0, top);
      };

      var pickedProducts = function () {
        return answers.picks.map(productById).filter(Boolean);
      };

      var sumFor = function (list, schedule) {
        var size = SCHEDULE_SIZE[schedule];
        return list.reduce(function (sum, product) {
          var variant = product.variants[size];
          sum.member += planForFrequency(variant, schedule).memberPrice;
          sum.regular += variant.price;
          return sum;
        }, { member: 0, regular: 0 });
      };

      // Free shipping at $49.99+ per order (store rule). Progress for a planned order.
      var FREE_SHIP = 4999;
      var shipMessage = function (total) {
        return total >= FREE_SHIP
          ? '<b>Free shipping</b> unlocked'
          : '<b>' + money(FREE_SHIP - total) + '</b> away from free shipping';
      };
      var renderShip = function (node, total) {
        if (!node) return;
        var pct = Math.min(100, Math.round(total / FREE_SHIP * 100));
        node.classList.toggle('is-free', total >= FREE_SHIP);
        node.querySelector('.apsm-ship__track i').style.width = pct + '%';
        node.querySelector('.apsm-ship__msg').innerHTML = shipMessage(total);
      };

      var renderMoodThumbs = function () {
        guide.querySelectorAll('[data-apsm-mood-thumbs]').forEach(function (stack) {
          stack.innerHTML = bestLoved(stack.dataset.apsmMoodThumbs, 3, '30').map(function (product) {
            return '<img src="' + escapeHtml(product.image) + '" alt="" width="64" height="64" loading="lazy">';
          }).join('');
        });
      };

      var renderSchedulePrices = function () {
        ['biweekly', 'monthly', 'bimonthly'].forEach(function (schedule) {
          var node = guide.querySelector('[data-apsm-schedule-price="' + schedule + '"]');
          // Every scent costs the same at a given size, so any N give the real total.
          var sum = sumFor(bestLoved('mix', answers.diffusers || 1, SCHEDULE_SIZE[schedule]), schedule);
          node.innerHTML = '<strong data-cents="0">' + money(0) + '</strong> per delivery' +
            (schedule === 'biweekly' ? ' <span>· about ' + money(Math.round(sum.member * 26 / 12)) + '/month</span>' : '') +
            '<span class="apsm-ship-tag' + (sum.member >= FREE_SHIP ? ' is-free' : '') + '">' +
            (sum.member >= FREE_SHIP ? 'Free shipping' : money(FREE_SHIP - sum.member) + ' from free shipping') + '</span>';
          countUp(node.querySelector('strong'), sum.member);
        });
      };

      // selectionOnly: a pick/unpick or bottle-count change. Update the existing
      // cards in place instead of rebuilding the grid (no flash, no scroll jump).
      var renderPicker = function (selectionOnly) {
        var size = guideSize();
        var need = answers.bottles;
        var left = need - answers.picks.length;
        var labels = slotLabels();
        guide.querySelector('[data-apsm-pick-title]').textContent = need === 1 ? 'Pick your scent' : (roomCount() ? 'Pick a scent for each room' : 'Pick your ' + need + ' scents');
        guide.querySelectorAll('[data-pick-schedule]').forEach(function (button) {
          var on = button.dataset.pickSchedule === answers.schedule;
          button.classList.toggle('is-on', on);
          button.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        guide.querySelectorAll('[data-pick-size]').forEach(function (chip) {
          var chipSize = chip.dataset.pickSize;
          var sample = products.find(function (product) {
            var variant = product.variants ? product.variants[chipSize] : null;
            return variant && variant.available && planForFrequency(variant, answers.schedule);
          });
          var on = chipSize === size;
          chip.classList.toggle('is-on', on);
          chip.setAttribute('aria-pressed', on ? 'true' : 'false');
          chip.disabled = !sample;
          if (!sample) { chip.querySelector('[data-pick-size-price]').textContent = 'Unavailable'; return; }
          var plan = planForFrequency(sample.variants[chipSize], answers.schedule);
          chip.querySelector('[data-pick-size-price]').textContent = money(plan.memberPrice);
          chip.querySelector('[data-pick-size-perml]').textContent = '$' + ((plan.memberPrice / 100) / Number(chipSize)).toFixed(2) + '/ml';
        });
        guide.querySelector('[data-apsm-pick-bottles]').textContent = need;
        guide.querySelector('[data-apsm-pick-minus]').disabled = need <= 1;

        guide.querySelectorAll('[data-pick-tab]').forEach(function (tab) {
          var on = tab.dataset.pickTab === answers.tab && !answers.query;
          tab.classList.toggle('is-on', on);
          tab.setAttribute('aria-selected', on ? 'true' : 'false');
        });

        var hasRooms = roomCount() > 0;
        var cardLabel = function (order) {
          return order === -1 ? '' : (hasRooms && labels[order] ? labels[order].toUpperCase() : 'ADDED · ' + (order + 1));
        };
        if (selectionOnly) {
          pickGrid.querySelectorAll('[data-pick-id]').forEach(function (card) {
            var order = answers.picks.indexOf(String(card.dataset.pickId));
            card.classList.toggle('is-picked', order !== -1);
            card.setAttribute('aria-pressed', order !== -1 ? 'true' : 'false');
            card.dataset.pickedLabel = cardLabel(order);
          });
        }
        var query = answers.query;
        var inTab = function (product) { return answers.tab === 'all' || product.category === answers.tab; };
        var familiesNode = guide.querySelector('[data-apsm-pick-families]');
        if (!selectionOnly && familiesNode) {
          // Family chips: only families present in the current tab, each with its count.
          var tabList = pickable().filter(inTab);
          familiesNode.innerHTML = SCENT_FAMILIES.map(function (family) {
            var count = tabList.filter(function (product) { return productFamilies(product).indexOf(family.key) !== -1; }).length;
            if (!count) return '';
            var on = answers.family === family.key;
            return '<button type="button" class="apsm-pick__family' + (on ? ' is-on' : '') + '" data-pick-family="' + family.key + '" aria-pressed="' + on + '">' + family.label + '<span>' + count + '</span></button>';
          }).join('');
        }
        var list = selectionOnly ? [] : pickable().filter(function (product) {
          if (query) return (product.title + ' ' + product.notes).toLowerCase().indexOf(query) !== -1;
          return inTab(product) && (!answers.family || productFamilies(product).indexOf(answers.family) !== -1);
        });
        if (!selectionOnly) {
          pickGrid.innerHTML = list.length ? list.map(function (product, index) {
            var order = answers.picks.indexOf(String(product.id));
            return cardHtml(product, { size: size, frequency: answers.schedule, picked: order !== -1, idAttr: 'data-pick-id', label: cardLabel(order), style: '--i:' + Math.min(index, 11) });
          }).join('') : '<p class="apsm-pick__empty">No scents match “' + escapeHtml(query) + '”. Try a note like vanilla, citrus or wood.</p>';
        }

        var picked = pickedProducts();
        var slots = '';
        for (var index = 0; index < need; index += 1) {
          var product = picked[index];
          slots += product
            ? '<button type="button" class="apsm-pick__slot is-on" data-pick-remove="' + escapeHtml(product.id) + '" aria-label="Remove ' + escapeHtml(product.title) + ' from ' + escapeHtml(labels[index]) + '" title="' + escapeHtml(labels[index]) + '"><img src="' + escapeHtml(product.image) + '" alt=""><span aria-hidden="true">×</span></button>'
            : '<span class="apsm-pick__slot' + (index === picked.length ? ' is-next' : '') + '" title="' + escapeHtml(labels[index]) + '">' + (index + 1) + '</span>';
        }
        guide.querySelector('[data-apsm-pick-slots]').innerHTML = slots;
        // Desktop side rail: the same picks as a labelled list.
        var railList = guide.querySelector('[data-apsm-pick-list]');
        if (railList) {
          var rows = '';
          for (var r = 0; r < need; r += 1) {
            var item = picked[r];
            rows += item
              ? '<li class="is-on"><img src="' + escapeHtml(item.image) + '" alt="" width="48" height="48"><span><small>' + escapeHtml(labels[r]) + '</small><b>' + escapeHtml(item.title) + '</b></span><button type="button" data-pick-remove="' + escapeHtml(item.id) + '" aria-label="Remove ' + escapeHtml(item.title) + '">×</button></li>'
              : '<li class="' + (r === picked.length ? 'is-next' : '') + '"><span class="apsm-pick__list-empty">' + (r + 1) + '</span><span><small>' + escapeHtml(labels[r]) + '</small><b>Choose a scent</b></span></li>';
          }
          railList.innerHTML = rows;
          guide.querySelector('[data-apsm-pick-rail-count]').textContent = picked.length + '/' + need;
        }
        var sum = sumFor(picked, answers.schedule);
        // Shipping progress uses the planned order: every slot at this size's member price.
        var unit = pickable()[0];
        var planned = unit ? planForFrequency(unit.variants[size], answers.schedule).memberPrice * need : sum.member;
        renderShip(guide.querySelector('[data-apsm-pick-ship]'), planned);
        guide.querySelector('[data-apsm-pick-status]').innerHTML = left > 0
          ? (need > 1 && roomCount() ? 'Next up: <b>' + escapeHtml(labels[picked.length]) + '</b> · ' : '') + answers.picks.length + ' of ' + need + ' picked'
          : '<b>All ' + need + ' picked</b> · ' + money(sum.member) + ' per delivery<small>Tap another scent to add a bottle</small>';
        var next = guide.querySelector('[data-apsm-pick-next]');
        next.disabled = left !== 0;
        next.textContent = left > 0 ? 'Pick ' + left + ' more' : 'See my plan';
      };

      var renderPlan = function () {
        var size = guideSize();
        var picks = pickedProducts();
        var sum = sumFor(picks, answers.schedule);
        var count = picks.length;
        var cadence = { biweekly: 'every 2 weeks', monthly: 'every month', bimonthly: 'every 2 months' }[answers.schedule];
        guide.querySelector('[data-apsm-plan-title]').textContent = count === 1
          ? 'Your scent, ' + cadence + '.'
          : 'Your ' + count + ' scents, ' + cadence + '.';
        var labels = slotLabels();
        guide.querySelector('[data-apsm-plan-picks]').innerHTML = picks.map(function (product, index) {
          return '<li style="--n:' + index + '"><img src="' + escapeHtml(product.image) + '" alt="" width="72" height="72" loading="lazy"><span><b class="apsm-plan__room">' + escapeHtml(labels[index]) + '</b><strong>' + escapeHtml(product.title) + '</strong><small>' + escapeHtml(product.notes || '') + '</small></span><em>' + size + ' ml</em></li>';
        }).join('');
        var totalNode = guide.querySelector('[data-apsm-plan-total]');
        totalNode.dataset.cents = Math.round(sum.regular);
        countUp(totalNode, sum.member);
        guide.querySelector('[data-apsm-plan-regular]').textContent = money(sum.regular);
        var free = sum.member >= 4999;
        guide.querySelector('[data-apsm-plan-meta]').innerHTML = '<b>Save ' + 20 + '%</b> · ' + count + ' × ' + size + ' ml · ' + cadence +
          ' · ' + (free ? '<span class="apsm-plan__free">Free shipping</span>' : 'Shipping at checkout');
        guide.querySelector('[data-apsm-plan-ship]').innerHTML = free
          ? '<b>Free shipping</b> on every delivery. Each box lasts until the next.'
          : 'Shipping calculated at checkout. <span>Free on orders of $49.99+.</span>';
        guide.querySelector('[data-apsm-guide-checkout]').innerHTML = 'Start my membership <span class="apsm-plan__cta-price">· ' + money(sum.member) + '</span>';
      };

      var applyPlanToBuilder = function () {
        state.frequency = answers.schedule;
        state.size = guideSize();
        state.bottleCount = answers.bottles;
        state.selected = answers.picks.slice();
        builder.querySelectorAll('[data-frequency]').forEach(function (item) {
          var active = item.dataset.frequency === state.frequency;
          item.classList.toggle('is-on', active);
          item.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        builder.querySelectorAll('[data-size]').forEach(function (item) {
          var active = item.dataset.size === state.size;
          item.classList.toggle('is-on', active);
          item.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        render();
      };

      // Drop picks the chosen size/schedule can't ship, and any over the bottle count.
      var tidyPicks = function () {
        var ok = pickable().map(function (product) { return String(product.id); });
        answers.picks = answers.picks.filter(function (id) { return ok.indexOf(id) !== -1; }).slice(0, answers.bottles);
      };

      var current = 'intro';
      var show = function (name, push) {
        if (SCREENS.indexOf(name) === -1) name = 'intro';
        if (name === 'mood' && !answers.diffusers) name = 'diffusers';
        if (name === 'schedule' && !answers.mood) name = answers.diffusers ? 'mood' : 'diffusers';
        if (name === 'scents' && !answers.schedule) name = 'intro';
        if (name === 'plan' && (!answers.schedule || answers.picks.length !== answers.bottles)) name = answers.schedule ? 'scents' : 'intro';
        if (name === 'diffusers') renderRooms();
        if (name === 'schedule') renderSchedulePrices();
        if (name === 'scents') { tidyPicks(); renderPicker(); }
        if (name === 'plan') {
          renderPlan();
          // Keep the builder below (and its sticky bar) showing the same plan.
          applyPlanToBuilder();
        }
        if (name === 'intro') requestAnimationFrame(function () { guide.dispatchEvent(new Event('apsm:screen')); });
        guide.dataset.dir = SCREENS.indexOf(name) >= SCREENS.indexOf(current) ? 'fwd' : 'back';
        current = name;
        guide.dataset.step = name;
        guide.querySelectorAll('[data-apsm-screen]').forEach(function (screen) {
          var active = screen.dataset.apsmScreen === name;
          screen.hidden = !active;
          screen.classList.toggle('is-active', active);
          if (active) stagger(screen);
        });
        bar.hidden = name === 'intro';
        // Immersive header (snippets/ap-immersive-header) owns back + start over.
        if (window.APIM && window.APIM.sync) window.APIM.sync({ back: true, restart: false });
        // Phones: the first four screens fit the viewport with no scrolling; only the
        // scent picker and the plan scroll (owner 2026-10-05).
        document.documentElement.classList.toggle('apsm-fit', ['intro', 'diffusers', 'mood', 'schedule'].indexOf(name) !== -1);
        var reached = SCREENS.indexOf(name);
        guide.querySelectorAll('[data-dot]').forEach(function (dot) {
          dot.classList.toggle('is-on', SCREENS.indexOf(dot.dataset.dot) <= reached);
        });
        guide.querySelectorAll('[data-apsm-answer]').forEach(function (option) {
          var on = String(answers[option.dataset.apsmAnswer]) === option.dataset.value;
          option.classList.toggle('is-on', on);
          option.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        updateFootVisibility();
        if (push) {
          history.pushState({ apsmScreen: name }, '', '#plan-' + name);
          var heading = guide.querySelector('[data-apsm-screen="' + name + '"] h2');
          if (heading) heading.focus({ preventScroll: true });
          var scroller = guide.querySelector('[data-apsm-pick-scroll]');
          if (scroller && name === 'scents') scroller.scrollTop = 0;
          // Phones scroll the page itself: start each step at the top.
          window.scrollTo(0, 0);
        }
        track('scent_membership_guide_step', { step: name });
      };

      guide.addEventListener('click', function (event) {
        var go = event.target.closest('[data-apsm-guide-go]');
        var answer = event.target.closest('[data-apsm-answer]');
        var pick = event.target.closest('[data-pick-id]');
        var unpick = event.target.closest('[data-pick-remove]');
        var tab = event.target.closest('[data-pick-tab]');
        var room = event.target.closest('[data-room]');
        var skip = event.target.closest('[data-apsm-guide-skip]');
        var schedulePick = event.target.closest('[data-pick-schedule]');
        var sizePick = event.target.closest('[data-pick-size]');
        if (skip) {
          event.preventDefault();
          event.stopPropagation();
          if (!answers.schedule) answers.schedule = 'biweekly';
          if (!answers.size) answers.size = SCHEDULE_SIZE[answers.schedule];
          if (!answers.bottles) answers.bottles = answers.diffusers || 3;
          track('scent_membership_guide_skip', { from: current });
          show('scents', true);
        } else if (schedulePick) {
          answers.schedule = schedulePick.dataset.pickSchedule;
          tidyPicks();
          renderPicker();
        } else if (sizePick && !sizePick.disabled) {
          answers.size = sizePick.dataset.pickSize;
          track('scent_membership_size_selected', { size_ml: answers.size, source: 'guide' });
          tidyPicks();
          renderPicker();
        } else if (go) {
          show(go.dataset.apsmGuideGo, true);
        } else if (room) {
          var key = room.dataset.room;
          var where = answers.rooms.indexOf(key);
          if (where === -1) answers.rooms.push(key); else answers.rooms.splice(where, 1);
          track('scent_membership_guide_room', { room: key, on: where === -1 });
          renderRooms();
        } else if (event.target.closest('[data-room-extra-plus]')) {
          answers.extraRooms += 1;
          renderRooms();
        } else if (event.target.closest('[data-room-extra-minus]')) {
          answers.extraRooms = Math.max(0, answers.extraRooms - 1);
          renderRooms();
        } else if (event.target.closest('[data-apsm-rooms-next]')) {
          answers.diffusers = roomCount();
          answers.bottles = answers.diffusers;
          answers.picks = answers.picks.slice(0, answers.bottles);
          track('scent_membership_guide_answer', { question: 'diffusers', answer: answers.diffusers, rooms: answers.rooms.join(',') });
          show('mood', true);
        } else if (answer) {
          var key = answer.dataset.apsmAnswer;
          var value = answer.dataset.value;
          if (key === 'mood') {
            answers.mood = value;
            answers.tab = value === 'mix' ? 'all' : value;
          } else {
            answers[key] = value;
            if (key === 'schedule') answers.size = SCHEDULE_SIZE[value];
          }
          track('scent_membership_guide_answer', { question: key, answer: value });
          show(SCREENS[SCREENS.indexOf(key) + 1], true);
        } else if (pick) {
          var id = String(pick.dataset.pickId);
          var at = answers.picks.indexOf(id);
          if (at !== -1) {
            answers.picks.splice(at, 1);
          } else {
            // Every slot full? Picking another scent adds a bottle.
            var grew = answers.picks.length >= answers.bottles;
            if (grew) answers.bottles += 1;
            answers.picks.push(id);
            track('scent_membership_guide_scent_picked', { product_id: id, added_bottle: grew });
            var flyFrom = pick.querySelector('img');
            renderPicker(true);
            flyToSlot(flyFrom, answers.picks.length - 1);
            if (grew) {
              var bottlesNode = guide.querySelector('[data-apsm-pick-bottles]');
              bottlesNode.classList.remove('is-bump');
              void bottlesNode.offsetWidth;
              bottlesNode.classList.add('is-bump');
            }
            return;
          }
          renderPicker(true);
        } else if (unpick) {
          answers.picks = answers.picks.filter(function (pid) { return pid !== String(unpick.dataset.pickRemove); });
          renderPicker(true);
        } else if (event.target.closest('[data-pick-family]')) {
          var family = event.target.closest('[data-pick-family]').dataset.pickFamily;
          answers.family = answers.family === family ? '' : family;
          answers.query = '';
          pickSearch.value = '';
          track('scent_membership_guide_family', { family: answers.family || 'all' });
          renderPicker();
          toResultsTop();
        } else if (tab) {
          answers.tab = tab.dataset.pickTab;
          answers.family = '';
          answers.query = '';
          pickSearch.value = '';
          renderPicker();
          toResultsTop();
        } else if (event.target.closest('[data-apsm-pick-plus]')) {
          answers.bottles += 1;
          renderPicker(true);
        } else if (event.target.closest('[data-apsm-pick-minus]')) {
          if (answers.bottles > 1) {
            answers.bottles -= 1;
            answers.picks = answers.picks.slice(0, answers.bottles);
            renderPicker(true);
          }
        } else if (event.target.closest('[data-apsm-pick-next]')) {
          show('plan', true);
        } else if (event.target.closest('[data-apsm-guide-pick-again]')) {
          history.back();
        } else if (event.target.closest('[data-apsm-guide-checkout]')) {
          applyPlanToBuilder();
          submit(event.target.closest('[data-apsm-guide-checkout]'));
        }
      });

      pickSearch.addEventListener('input', function () {
        answers.query = pickSearch.value.trim().toLowerCase();
        renderPicker();
      });

      root.querySelectorAll('[data-apsm-guide-restart]').forEach(function (link) {
        link.addEventListener('click', function (event) {
          event.preventDefault();
          show('diffusers', true);
        });
      });

      window.addEventListener('popstate', function (event) {
        var name = event.state && event.state.apsmScreen;
        if (!name && /^#plan-/.test(location.hash)) name = location.hash.slice(6);
        show(name || 'intro', false);
      });

      window.APIM = window.APIM || {};
      // On the intro, back leaves the page (to where the shopper came from, else home).
      window.APIM.back = function () {
        if (current !== 'intro') { history.back(); return; }
        var from = document.referrer ? new URL(document.referrer) : null;
        var cameFromStore = from && from.host === location.host && from.pathname !== location.pathname;
        location.href = cameFromStore ? from.href : '/';
      };
      window.APIM.restart = function () { show('intro', true); };

      /* FAQ / how-it-works sheet over the app. */
      var sheet = root.querySelector('[data-apsm-sheet]');
      var sheetReturn = null;
      var closeSheet = function () {
        if (!sheet || sheet.hidden) return;
        sheet.hidden = true;
        if (sheetReturn) sheetReturn.focus();
      };
      // FAQ lives in the immersive header as a "?" button (replaces the in-page pills).
      var head = document.querySelector('.apim-head');
      if (head && !head.querySelector('[data-apsm-sheet-open]')) {
        var faqButton = document.createElement('button');
        faqButton.type = 'button';
        faqButton.className = 'apim-head__btn apsm-head-faq';
        faqButton.setAttribute('data-apsm-sheet-open', '');
        faqButton.setAttribute('aria-label', 'Questions: how membership works');
        faqButton.innerHTML = '<span class="apsm-head-faq__q" aria-hidden="true">?</span><span class="apsm-head-faq__t">FAQ</span>';
        head.appendChild(faqButton);
      }
      document.addEventListener('click', function (event) {
        var opener = event.target.closest('[data-apsm-sheet-open]');
        if (opener && sheet) {
          sheetReturn = opener;
          sheet.hidden = false;
          sheet.querySelector('[data-apsm-sheet-close]').focus();
          track('scent_membership_faq_opened', { from: current });
        } else if (event.target.closest('[data-apsm-sheet-close]')) {
          closeSheet();
        }
      });
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') closeSheet();
      });

      guide.addEventListener('keydown', function (event) {
        var card = event.target.closest('[data-pick-id]');
        if (card && (event.key === 'Enter' || event.key === ' ')) {
          event.preventDefault();
          card.click();
        }
      });
      guide.addEventListener('pointerdown', ripple);

      // One full-screen app: the page itself doesn't scroll (only the scent grid does).
      document.documentElement.classList.add('apsm-app');
      var syncChrome = function () {
        var head = document.querySelector('.apim-head');
        document.documentElement.style.setProperty('--apsm-head', (head ? head.offsetHeight : 0) + 'px');
      };
      syncChrome();
      window.addEventListener('resize', syncChrome);

      // Desktop hero: centre the four bottles in the photo column at any size.
      // In the zoomed-out 3:4 desktop art (hero-desktop-v4) the bottle group sits ~30–70% across, ~48–75% down.
      var heroImg = guide.querySelector('.apsm-guide__media img');
      var frameHero = function () {
        if (!heroImg) return;
        if (window.innerWidth <= 900 || !heroImg.naturalWidth) {
          heroImg.style.objectPosition = '';
          heroImg.style.transformOrigin = '';
          return;
        }
        var box = heroImg.getBoundingClientRect();
        if (!box.width || !box.height) return;
        var ratio = heroImg.naturalWidth / heroImg.naturalHeight;
        var fx = Math.min(1, box.width / (box.height * ratio));   // visible share of the art's width
        var fy = Math.min(1, box.height / (box.width / ratio));   // visible share of its height
        var place = function (centre, visible) {
          var start = Math.max(0, Math.min(1 - visible, centre - visible / 2));
          return { pos: visible < 1 ? start / (1 - visible) : 0.5, inBox: (centre - start) / visible };
        };
        var x = place(0.5, fx);
        var y = place(0.6, fy);
        heroImg.style.objectPosition = (x.pos * 100).toFixed(2) + '% ' + (y.pos * 100).toFixed(2) + '%';
        heroImg.style.transformOrigin = (x.inBox * 100).toFixed(1) + '% ' + (y.inBox * 100).toFixed(1) + '%';
      };
      if (heroImg) {
        if (heroImg.complete) frameHero(); else heroImg.addEventListener('load', frameHero);
        window.addEventListener('resize', frameHero);
      }

      // Headline reveals word by word.
      var headline = guide.querySelector('#apsm-title');
      if (headline && !headline.dataset.split) {
        headline.dataset.split = '1';
        headline.setAttribute('aria-label', headline.textContent);
        headline.innerHTML = headline.textContent.trim().split(/\s+/).map(function (word, index) {
          return '<span class="apsm-word" aria-hidden="true" style="--w:' + index + '">' + escapeHtml(word) + '</span>';
        }).join(' ');
      }

      // Intro offer: cheapest 2-week member bottle, straight from the catalog.
      var cheapest = null;
      products.forEach(function (product) {
        Object.keys(product.variants || {}).forEach(function (size) {
          var variant = product.variants[size];
          var plan = variant && variant.available && planForFrequency(variant, 'biweekly');
          if (plan && (!cheapest || plan.memberPrice < cheapest.member)) cheapest = { member: plan.memberPrice, regular: variant.price };
        });
      });
      if (cheapest) {
        guide.querySelectorAll('[data-apsm-from-price]').forEach(function (n) { n.textContent = money(cheapest.member); });
        guide.querySelectorAll('[data-apsm-from-regular]').forEach(function (n) { n.textContent = money(cheapest.regular); });
        // Yearly savings for a typical plan: 3 starter bottles every 2 weeks (26 deliveries).
        var yearly = (cheapest.regular - cheapest.member) * 3 * 26;
        var saveNode = guide.querySelector('[data-apsm-yearly]');
        if (saveNode && yearly > 0) {
          guide.querySelector('[data-apsm-yearly-amount]').textContent = money(yearly).replace(/\.00$/, '');
          var basisNode = guide.querySelector('[data-apsm-yearly-basis]');
          basisNode.textContent = '*Based on 3 starter bottles every 2 weeks at member pricing.';
          basisNode.hidden = false;
          saveNode.hidden = false;
        }
      }
      // Review count ticks up to the real Judge.me total.
      var reviewNode = guide.querySelector('[data-apsm-count-to]');
      if (reviewNode) {
        var target = Number(reviewNode.dataset.apsmCountTo) || 0;
        var format = function (n) { return Math.round(n).toLocaleString('en-US'); };
        if (reducedMotion) {
          reviewNode.textContent = format(target);
        } else {
          var began = null;
          var tick = function (now) {
            if (!began) began = now;
            var t = Math.min(1, (now - began) / 1400);
            reviewNode.textContent = format(target * (1 - Math.pow(1 - t, 4)));
            if (t < 1) requestAnimationFrame(tick);
          };
          requestAnimationFrame(tick);
        }
      }

      // Explainer: real product photos (one hotel, perfume, nature) + live dates.
      var explainer = guide.querySelector('[data-apsm-ex]');
      if (explainer) {
        var faces = ['hotel', 'perfume', 'nature'].map(function (key) { return bestLoved(key, 1, '30')[0]; });
        explainer.querySelectorAll('[data-ex-img]').forEach(function (img) {
          var product = faces[Number(img.dataset.exImg)];
          if (product) img.src = product.image.replace(/width=\d+/, 'width=200');
        });
        var now = new Date();
        var next = new Date(now.getTime() + 14 * 864e5);
        var month = function (d) { return d.toLocaleString('en-US', { month: 'short' }); };
        explainer.querySelector('[data-ex-month-now]').textContent = month(now);
        explainer.querySelector('[data-ex-day-now]').textContent = now.getDate();
        explainer.querySelector('[data-ex-month-next]').textContent = month(next);
        explainer.querySelector('[data-ex-day-next]').textContent = next.getDate();
      }

      // Size the explainer to the space it actually has (no dead bands), and lay it
      // out statically for reduced-motion visitors: all three steps at once.
      var fitExplainer = function () {
        var ex = guide.querySelector('.apsm-intro-sell .apsm-ex');
        if (!ex || !ex.offsetParent) return;
        // Owner 2026-10-05: the explainer plays (with images) for reduced-motion users too.
        var reduce = false;
        var mobile = window.innerWidth <= 900;
        var stage = ex.querySelector('.apsm-ex__stage');
        ex.classList.remove('is-rows', 'is-cols', 'is-side', 'no-vis', 'is-list');
        ex.style.setProperty('--exs', '1');
        // Reduced motion: a clean numbered "How it works" list (no pictures); very short
        // screens get a compact 3-column text row instead. Nothing to measure or clip.
        if (reduce) {
          ex.classList.add(stage.clientHeight >= 150 || !mobile ? 'is-list' : 'is-cols');
          if (ex.classList.contains('is-cols')) ex.classList.add('no-vis');
          return;
        }
        var W = stage.clientWidth;
        var H = stage.clientHeight;
        var copyH = Math.max.apply(null, [].map.call(ex.querySelectorAll('.apsm-ex__copy'), function (c) { return c.offsetHeight; }));
        var scale;
        if (!mobile) {
          scale = reduce ? 0.62 : 1;
        } else if (reduce && ex.classList.contains('is-rows')) {
          scale = Math.min((H - 24) / 3 / 74, (W * 0.42) / 132);
        } else if (reduce) {
          scale = Math.min((H - copyH - 10) / 74, ((W - 16) / 3) / 132);
        } else if (H - copyH - 14 >= 56) {
          scale = Math.min((H - copyH - 14) / 74, (W * 0.9) / 132);
        } else {
          ex.classList.add('is-side');
          scale = Math.min((H - 4) / 74, (W * 0.38) / 132);
        }
        // Too little room for pictures in the static layout: steps as text only.
        if (reduce && mobile && scale < 0.62) ex.classList.add('no-vis');
        ex.style.setProperty('--exs', Math.max(0.5, Math.min(2.4, scale)).toFixed(3));
      };
      window.addEventListener('resize', fitExplainer);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitExplainer);
      guide.addEventListener('apsm:screen', fitExplainer);

      renderMoodThumbs();
      history.replaceState({ apsmScreen: 'intro' }, '', location.pathname + location.search);
      show('intro', false);
    }

    render();
    updateFootVisibility();
  }

  document.querySelectorAll('[data-apsm]').forEach(init);
}());
